import { render, staticRenderFns } from "./testOverview.vue?vue&type=template&id=6513e607&scoped=true&"
import script from "./testOverview.vue?vue&type=script&lang=js&"
export * from "./testOverview.vue?vue&type=script&lang=js&"
import style0 from "./testOverview.vue?vue&type=style&index=0&id=6513e607&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513e607",
  null
  
)

export default component.exports